import { PathOptions } from "leaflet";

export const rodovias_estaduais = (feature: any): PathOptions => {
  return {
    color: "#FFA500",
    weight: 2,
    opacity: 1,
  };
};
